module.exports = __webpack_public_path__ + "static/raleigh-a2a677bbe128404c55ed327953f5288a.png";